import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_setting.png';
const _withScopeId = n => (_pushScopeId("data-v-5abffa62"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "triangle-down"
}, null, -1));
const _hoisted_3 = {
  key: 0,
  style: {},
  class: "li-item"
};
import { ref } from 'vue';
const __default__ = {
  name: "TableColumnOptionBtn"
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    columnList: {
      type: Array,
      default: []
    }
  },
  emits: ['filter-columnItem-change'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const filterColumnList = ref(props.columnList.filter(item => {
      item.isSelect = false;
      if (item.controller) {
        if (item.controller(item)) {
          return item;
        }
      } else {
        return item;
      }
      ;
    }));
    const filterColumnItemChange = (valid, item) => {
      item.isSelect = !valid;
      emit('filter-columnItem-change');
    };
    //监听传入columnList的变化，popover列表选项响应式变化
    watch(() => props.columnList, newVal => {
      filterColumnList.value = newVal.filter(item => {
        item.isSelect = false;
        if (item.controller) {
          if (item.controller(item)) {
            return item;
          }
        } else {
          return item;
        }
        ;
      });
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createBlock(_component_el_popover, {
        trigger: "hover",
        "popper-style": "min-width: 150px; width: auto; box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          style: {
            "margin-left": "12px",
            "border": "none",
            "background": "transparent",
            "padding": "0"
          }
        }, {
          default: _withCtx(() => [_hoisted_1, _hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterColumnList.value, item => {
          return _openBlock(), _createElementBlock(_Fragment, null, [item.prop ? (_openBlock(), _createElementBlock("li", _hoisted_3, [_createVNode(_component_el_checkbox, {
            onChange: valid => filterColumnItemChange(valid, item),
            checked: !item.isSelect,
            "model-value": !item.isSelect
          }, null, 8, ["onChange", "checked", "model-value"]), _createTextVNode(" " + _toDisplayString(_ctx.$t(item.label)), 1)])) : _createCommentVNode("", true)], 64);
        }), 256))])]),
        _: 1
      });
    };
  }
});